module.exports = __webpack_public_path__ + "static/media/chorthippus_albomarginatus_004_APA.5a9c8d2e.mp3";